import { api } from '@/shared/lib/api';
import type { AuthUser } from '@/shared/auth/auth-store';

type LoginResponse = {
  data: {
    accessToken: string;
    expiresIn: number;
    user: AuthUser;
  };
};

export async function loginRequest(input: { username: string; password: string }): Promise<{
  accessToken: string;
  user: AuthUser;
}> {
  const res = await api.post<LoginResponse>('/auth/login', input);
  return { accessToken: res.data.data.accessToken, user: res.data.data.user };
}
